<template>
  <div>
    <modalUpload @save="saveFile"> </modalUpload>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-3 py-3 mb-5">
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('programDetails')">
              Detalhes do programa
            </h1>
            <h1 class="title">
              <span class="pb-2" v-text="$ml.get('dontForgetToSaveYourChanges')"
                >Não esqueça de salvar as alterações!</span
              >
            </h1>
            <div class="card mb-3">
              <div class="card-header" v-text="$ml.get('summary')">Resumo</div>
              <div class="card-body">
                <div class="row">
                  <div class="m-2 mr-4">
                    <span class="position-relative padding1">
                      <div class="avatar-wrapper mb-2" @click="showModal()">
                        <img
                          id="file_upload"
                          class="profile-pic"
                          :src="avatar"
                        />
                        <input
                          class="file-upload"
                          type="file"
                          accept="image/*"
                        />
                      </div>
                      <a
                        @click="showModal()"
                        class="ico-edit camUpload pointer"
                      >
                        <img
                          src="../../../../src/assets/icons/camera.svg"
                          class="ico-16 m-1"
                        />
                      </a>
                    </span>
                  </div>
                  <div class="col w-100 form-group mt-2">
                    <label v-text="$ml.get('title')">Título</label>
                    <input
                      maxlength="255"
                      type="text"
                      class="form-control"
                      v-model="name"
                      :disabled="true"
                      :placeholder="$ml.get('standoutCreate')"
                    />
                    <transition name="fade">
                      <label
                        v-if="validateError && !$v.name.required"
                        class="lblError"
                        v-text="$ml.get('theNameOfTheProgramMustBInformed')"
                        >O nome do programa deve ser informado</label
                      >
                      <label
                        v-if="validateError && !$v.name.regexOTN"
                        class="lblError"
                        v-text="$ml.get('cannotEnterSpecialCharacters')"
                        >Não é possível inserir caracteres especiais</label
                      >
                      <label
                        class="lblError"
                        v-if="validateError && !$v.name.minLength"
                        v-text="
                          $ml
                            .with('f', 3)
                            .with('l', 30)
                            .get('theProgramNameMustBeBetweenAndCharacters')
                        "
                        >>O nome do programa deve ter entre 3 e 30
                        caracteres</label
                      >
                    </transition>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div>
                      <textarea
                        style="background: #fafbfc"
                        maxlength="2000"
                        class="form-control-textarea text-are-mark"
                        rows="5"
                        v-model="description"
                        :disabled="true"
                        :placeholder="$ml.get('dashCreatNdaAbriefsummary')"
                      >
                      </textarea>
                    </div>
                    <!-- <transition name="fade">
                      <label
                        v-if="validateError && !$v.description.required"
                        class="lblError"
                        v-text="
                          $ml.get('theDescriptionOfTheProgramMustBeInformed')
                        "
                        >A descrição do programa deve ser informado</label
                      >
                      <label
                        class="lblError"
                        v-if="validateError && !$v.description.minLength"
                        v-text="
                          $ml
                            .with('f', 3)
                            .with('l', 30)
                            .get(
                              'theProgramDescriptionMustBeBetweenAndCharacters',
                            )
                        "
                        >A descrição do programa deve ter entre 3 e 30
                        caracteres!</label
                      >
                    </transition> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3 d-column flex-row">
              <div
                class="h-form h-profile-lg d-flex flex-column pb-3 align-items-center no"
              >
                <!-- Configurações -->
                <!-- <config
                  number="1"
                  :slug.sync="slug"
                  :errorSlug="
                    validateError && (!$v.slug.required || !$v.slug.minLength)
                  "
                  :programEdit="true"
                  :vpn_required="vpn_required"
                  :typeProgram="{ id: typeProgram, name: typeProgram }"
                  :page-edit="false"
                /> -->
                <!-- Objetivo do programa -->
                <programByObjective
                  v-if="targetSettings?.active"
                  @updatedTargets="updatedSettingsTargets"
                  @registeredPrograms="addSettingsTargets"
                  number="1"
                  :htmlText="htmlText"
                  :listProgramTarget="
                    targetSettings.targets.map((item) => ({
                      ...item,
                      delete: false,
                      edit: false,
                      currency: {
                        name: item.currency.toUpperCase(),
                        value: item.currency.toLowerCase(),
                      },
                    }))
                  "
                  :errorList.sync="errorList"
                  :edit="true"
                />

                <!-- Política do programa -->
                <policy
                  number="2"
                  :htmlText="htmlText"
                  :policy.sync="policy"
                  :errorPolicy="
                    validateError &&
                    (!$v.policy.minLength || !$v.policy.required)
                  "
                />

                <!-- Escopo -->
                <scope
                  v-if="typeProgram"
                  number="3"
                  :typeProgram="typeProgram"
                  :listScop="listScop"
                  :listScopRemove="listScopRemove"
                  :validateError="validateError"
                />
                <!--  Fora de Escopo -->
                <outOfScope
                  number="4"
                  :typeProgram="typeProgram"
                  :listOutOfScope="listOutOfScope"
                  :listOutOfScopeRemove="listOutOfScopeRemove"
                  :validateError="validateError"
                />
                <!-- Recompensas -->
                <rewards
                  v-if="typeProgram != 'vdp' && !targetSettings?.active"
                  number="5"
                  :bounty_severity="bounty_severity"
                  :optional_rewards="optional_rewards"
                  :currency="currency"
                />
                <!-- Concluir -->
                <div class="d-flex align-self-start">
                  <div
                    class="position-relative align-self-center d-flex align-items-center align-self-center"
                  >
                    <div
                      class="circle-number d-flex justify-content-center align-items-center"
                    >
                      <span>{{
                        targetSettings?.active ? 5 : typeProgram != "vdp" ? 6 : 5
                      }}</span>
                    </div>
                  </div>
                  <div class="pl-3 d-flex">
                    <div class="align-self-start mt-1">
                      <h2 class="size-1_4 m-0 pb-1">
                        <strong v-text="$ml.get('conclude')">Concluir</strong>
                      </h2>
                      <p class="d-flex align-items-center">
                        <span
                          class="align-self-center"
                          v-text="$ml.get('haveYouRevised')"
                        >
                          Revisou seu programa? Então pronto!
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-self-start h-profile">
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-4"></span>
                  </div>
                </div>

                <div class="d-flex align-self-start h-profile-circle">
                  <div class="circle d-flex justify-content-center">
                    <span class="circle-internal d-flex justify-content-center"
                      ><span class="circle-pending"></span
                    ></span>
                    <div class="h-line"><span></span></div>
                    <div class="v-line"><span class="pb-5"></span></div>
                  </div>
                  <div class="pl-3 d-flex w-100 align-items-center">
                    <div
                      class="d-flex flex-row justify-content-between align-items-start w-100"
                    >
                      <a
                        @click="validateForm()"
                        class="btn"
                        style="min-width:110px;"
                        >
                        <Spinner v-show="loadingBtn" />
                        <span v-show="!loadingBtn" v-text="$ml.get('saveEditions')">Salvar alterações</span>
                        </a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-modal
          id="modal-edit-program"
          class="my-modal"
          data-bs-keyboard="false"
          hide-header
          size="ml"
          footer-bg-variant="light"
        >
          <b-container
            fluid="lg"
            style="max-height: 20vh !important; overflow-y: auto !important"
          >
            <div class="col modal-body px-2">
              <h2
                class="size-1_4 m-0 pb-1"
                v-text="$ml.get('confirmProgramChanges')"
              ></h2>
            </div>
          </b-container>
          <form>
            <div class="col px-2">
              <svg
                @click="viewModalHtml()"
                width="24"
                height="24"
                class="ico-view-report"
              >
                <image
                  xlink:href="../../../assets/icons/eye.svg"
                  width="24"
                  height="24"
                />
              </svg>
              <svg
                v-show="modalHtml"
                @click="modalHtml = ''"
                width="24"
                height="24"
                class="ico-view-report"
              >
                <image
                  xlink:href="../../../assets/icons/eye-slash.svg"
                  width="24"
                  height="24"
                />
              </svg>
              <textarea
                v-show="!modalHtml"
                rows="8"
                v-model="changesDescription"
                @input="verifyModalMaxLenght()"
                class="form-control-textarea w-100 text-are-mark pr-5"
                ref="textarea"
                :placeholder="$ml.get('describeChangesMadeInProgram')"
              >
              </textarea>
              <div
                v-show="modalHtml"
                class="form-control w-100 h-100 pr-5"
                v-html="modalHtml"
              ></div>
              <div v-if="necessaryChangesDescription">
                <label class="lblError" v-text="$ml.get('describeEditsMade')"
                  >Descreva as edições feitas.</label
                >
              </div>
            </div>

            <transition name="fade">
              <label
                v-if="modalMaxLengt"
                class="lblError"
                v-text="$ml.with('5.000').get('maximumLengthIsCharacters')"
                >Tamanho máximo é de 5.000 caracteres</label
              >
            </transition>
          </form>
          <template #modal-footer>
            <div class="w-100 float px-2">
              <p
                class="float-left mb-3 primary-text"
                v-text="$ml.get('wantSaveChangesProgram')"
              >
                Você deseja mesmo salvar as alterações feitas neste programa?
              </p>
              <b-button
                variant="primary"
                size="sm"
                class="float-right btn-outline-extra"
                @click="closeEditModal()"
                v-text="$ml.get('cancel')"
              >
                Cancelar
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                class="float-right mr-3"
                @click="sendSummaryAndSaveEditions()"
                v-text="$ml.get('confirm')"
              >
                Confirmar!
              </b-button>
            </div>
          </template>
        </b-modal>
      </section>
    </main>
  </div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
// import Config from "../../../components/company/program/config.vue";
import OutOfScope from "../../../components/company/program/out_of_scope.vue";
import Policy from "../../../components/company/program/policy.vue";
import programByObjective from "../../../components/company/program/programByObjective.vue";
import Rewards from "../../../components/company/program/rewards.vue";
import Scope from "../../../components/company/program/scope.vue";
import modalUpload from "../../../components/modalUpload.vue";
import ProgramService from "../../../services/program.service";

import { utils } from "../../../utils";

const regexOTN = utils.regexCheck("OTN");

export default {
  components: {
    modalUpload,
    // Config,
    Scope,
    OutOfScope,
    Rewards,
    Policy,
    programByObjective,
  },
  data() {
    return {
      id: "",
      loadingBtn: false,
      loading: false,
      validateError: false,
      validateScopeError: false,
      file: null,
      avatar: require("../../../assets/images/empty.png"),

      input: ``,
      name: "",
      status: "",
      description: "",
      slug: "",
      typeProgram: "public",
      policy: ``,
      htmlText: ``,
      policyMaxLengt: false,
      modalMaxLengt: false,
      showEditModal: true,
      vpn_required: false,
      necessaryChangesDescription: false,
      currency: "",
      modalHtml: ``,
      changesDescription: ``,

      listScop: [],
      listScopRemove: [],

      listOutOfScope: [],
      listOutOfScopeRemove: [],

      bounty_severity: [],

      selectedOthersRewards: null,
      txtOtherRewards: null,
      optional_rewards: [],

      selectRewardOrType: [
        "Enviamos um brinde",
        "Agradecimento por e-mail",
        "Outros",
      ],

      managers: null,
      targetSettings: null,

      // errorProgram: "",
      errorList: "",
      filteredDataTarget: [],
      statusProgram: false,
    };
  },

  validations: {
    name: { required, regexOTN, minLength: minLength(3) },
    slug: { minLength: minLength(2) },
    description: { required, minLength: minLength(3) },
    policy: { required, minLength: minLength(3) },
    listScop: { required },
  },

  mounted() {
    this.$bvModal.show("modal-nda");
    this.id = this.$route.query.id;
    this.changeProgram(this.id);
  },
  computed: {
    listTargets(){
     return this.filteredDataTarget.filter(target => target.finishedAt === null);
    }
  },
  methods: {
    addSettingsTargets(data){
      this.filteredDataTarget = data.registeredPrograms.map(
        ({ currency, ...rest }) => ({
          ...rest,
          currency: currency.value,
        }),
      );
    },
    updatedSettingsTargets(data) {
      this.filteredDataTarget = data.updatedTargets.map(
        ({ currency, ...rest }) => ({
          ...rest,
          currency: currency.value,
        }),
      );
    },
    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(this.policy);
    },

    viewModalHtml() {
      this.modalHtml = this.$utils.convertMarkedOld(this.changesDescription);
    },

    verifyModalMaxLenght() {
      if (!this.changesDescription.length) {
        return (this.necessaryChangesDescription = true);
      }
      this.necessaryChangesDescription = false;
      if (this.changesDescription.length > 5000) {
        this.changesDescription = this.changesDescription.substring(0, 5000);
        this.modalMaxLengt = true;
      } else {
        this.modalMaxLengt = false;
      }
    },

    controlTextArea() {
      if (this.policy.length > 29900) {
        this.policy = this.policy.substring(0, 29900);
        this.policyMaxLengt = true;
      } else {
        this.policyMaxLengt = false;
      }
    },

    showModal() {
      this.$bvModal.show("modal-upload-avatar");
      setTimeout(() => {
        $("#avatarEditorCanvas").click();
      }, 50);
    },

    saveFile(file) {
      this.file = file.file;
      this.avatar = file.src;
    },

    changeProgram(id) {
      ProgramService.getProgramDetail(id).then(
        (response) => {
          $("html, body").animate({ scrollTop: 0 }, "5000");
          let file = response.data.avatar;
          var img = document.createElement("img");
          img.src = file;
          var self = this;
          img.onload = function () {
            self.avatar = file;
          };

          if (response.data.managers) {
            this.managers = response.data.managers;
          }
          this.targetSettings = response.data.target_settings;
          this.filteredDataTarget = response.data.target_settings.targets;
          this.vpn_required = response.data.vpn_required;

          this.name = response.data.name;
          this.status = response.data.status;
          this.statusProgram = response.data.status == "paused" ? true : false;

          this.description =
            !response.data.description ||
            response.data.description == `undefined` ||
            response.data.description == undefined
              ? ""
              : response.data.description;
          this.slug = response.data.slug;

          this.typeProgram = response.data.type;
          this.policy = response.data.policy;
          this.listScop = response.data.scope;
          this.listOutOfScope = response.data.outOfScope;
          this.bounty_severity.bounty_low = response.data.bounty_low;
          this.bounty_severity.bounty_medium = response.data.bounty_medium;
          this.bounty_severity.bounty_high = response.data.bounty_high;
          this.bounty_severity.bounty_critical = response.data.bounty_critical;
          this.bounty_severity.active_campaign = response.data.active_campaign;
          this.bounty_severity.campaign_situation =
            response.data.campaign_situation;
          this.bounty_severity.offers_double_bounty =
            response.data.offers_double_bounty;
          this.bounty_severity.offers_double_score =
            response.data.offers_double_score;
          this.bounty_severity.bounty_low_double =
            response.data.bounty_low_double;
          this.bounty_severity.bounty_medium_double =
            response.data.bounty_medium_double;
          this.bounty_severity.bounty_high_double =
            response.data.bounty_high_double;
          this.bounty_severity.bounty_critical_double =
            response.data.bounty_critical_double;
          this.bounty_severity.campaign_initial_date =
            response.data.campaign_initial_date;
          this.bounty_severity.campaign_final_date =
            response.data.campaign_final_date;
          this.bounty_severity.offers_double_bounty =
            response.data.offers_double_bounty;
          this.optional_rewards = response.data.optional_rewards
            ? response.data.optional_rewards
            : [];
          this.currency = response.data.currency;
        },
        () => {
          this.$router.push("/program");
        },
      );
    },

    validateForm() {
      this.loading = true;
      let self = this;
      this.$v.$touch();

      if (
        this.$v.name.$error ||
        // this.$v.description.$error ||
        this.$v.slug.$error ||
        (!this.slug && this.typeProgram != "private") ||
        this.$v.policy.$error ||
        this.$v.listScop.$error
      ) {
        this.validateError = true;
        this.loading = false;
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("fillInAllFieldHighlightedInRed"),
        });
        $("html, body").animate({ scrollTop: 0 }, "5000");
        return;
      }

      this.validateError = false;
      this.changesDescription = "";

      if (this.status == "pending") {
        this.saveProgram();
      } else {
        this.openEditModal();
      }
    },

    openEditModal() {
      this.$bvModal.show("modal-edit-program");
    },

    closeEditModal() {
      this.necessaryChangesDescription = false;
      this.$bvModal.hide("modal-edit-program");
    },

    sendSummaryAndSaveEditions() {
      if (!this.changesDescription.length) {
        return (this.necessaryChangesDescription = true);
      }
      const payload = { description: this.changesDescription };
      const id = this.$route.query.id;
      ProgramService.postProgramUpdateMessage(payload, id)
        .then(() => {
          this.saveProgram();
          this.closeEditModal();
        })
        .catch((error) => console.log(error.response));
    },

    saveProgram() {
      var self = this;
      this.loadingBtn = true;

      const formData = new FormData();

      if (this.file) {
        formData.append("file", this.file);
      }
      formData.append("name", this.name);

      if (
        this.description &&
        this.description != `undefined` &&
        this.description != undefined
      ) {
        formData.append("description", this.description);
      }

      if (this.slug && this.typeProgram != "private") {
        formData.append("slug", this.slug);
      }

      formData.append("policy", this.policy);

      var listTotalScope = this.listScop.concat(this.listScopRemove);
      var filteredOutOfScope = this.listOutOfScope.concat(
        this.listOutOfScopeRemove,
      );
      formData.append("scope", JSON.stringify(listTotalScope));
      formData.append("out_of_scope", JSON.stringify(filteredOutOfScope));

      formData.append("bounty_low", this.bounty_severity.bounty_low);
      formData.append("bounty_medium", this.bounty_severity.bounty_medium);
      formData.append("bounty_high", this.bounty_severity.bounty_high);
      formData.append("bounty_critical", this.bounty_severity.bounty_critical);
      formData.append(
        "optional_rewards",
        JSON.stringify(this.optional_rewards),
      );

      if (this.managers) {
        formData.append(
          "managers",
          JSON.stringify(this.managers?.map((manager) => manager._id)),
        );
      }
      if (this.targetSettings?.active) {
        const target_settings = {
          active: true,
          targets: this.filteredDataTarget.map((obj) => {
            if (obj.delete === false) {
              delete obj.delete;
            }
            delete obj.edit;
            delete obj.translated_policy;
            return obj;
          }),
        };
        formData.append("target_settings", JSON.stringify(target_settings));
      }

      const programId = this.$route.query.id;
      ProgramService.putProgram(formData, programId).then(
        () => {
          console.log(formData);
          this.changeProgram(this.$route.query.id);
          self.loading = false;
          Swal.fire({
            icon: "success",
            title: self.$ml.get("programSuccessfullyChanged"),
            showConfirmButton: false,
            timer: 2000,
          });
          
          var previousProgramStatus = this.statusProgram
          if(this.targetSettings?.active){
            setTimeout(() => {
            if(!previousProgramStatus && !this.listTargets.length){
            Swal.fire({
              icon: "info",
              title: "Atenção!",
              text: this.$ml.get('pauseProgramSwal'),
              showConfirmButton: false,
            });
          }
            }, 2000)
          }
        

          this.loadingBtn = false;        
        },
        (error) => {
          self.loading = false;
          this.loadingBtn = false;
          const splitMessage = error.response?.data?.message?.split("_");
          const errorType = splitMessage[1] + splitMessage[2] + splitMessage[3];

          if (errorType === "scopelimitexceeded") {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("scopeLimitExceeded"),
            });
          } else if (
            error.response.data.message ==
            "Já existe um programa cadastrado com essa slug!"
          ) {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("thereIsAlreadyProgramSlug"),
            });
          } else if (
            error.response.data.message ==
            "Já existe um programa cadastrado com esse nome!"
          ) {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("thereIsAlreadyAprogram"),
            });
          } else {
            Swal.fire({
              icon: "info",
              title: "",
              text: self.$ml.get("unableToCompleteThisRequest"),
            });
          }
        },
      );
    },
  },
};
</script>
<style scoped>
.avatar-wrapper {
  height: 85px;
  width: 85px;
}

body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown),
html.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  height: 100% !important;
  overflow-y: visible !important;
}
.primary-text {
  color: #730ba9 !important;
}

.modal-textarea {
  height: 50vh;
}
</style>
